import { useCallback, useEffect, useState } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import { cookies } from '../config/cookies';

let cookieConsentInitialized = false;

export const showCookiePreferences = () => {
    CookieConsent.showPreferences();
};

const useCookies = (isApp: boolean) => {
    const [requiredCookieAccepted, setRequiredCookieAccepted] = useState(false);
    const [optionalCookieAccepted, setOptionalCookieAccepted] = useState(false);

    const syncCookieConsent = useCallback((cookie: CookieConsent.CookieValue) => {
        const categories = cookie.categories || [];

        setRequiredCookieAccepted(categories.includes('necessary'));
        setOptionalCookieAccepted(categories.includes('analytics'));
    }, []);

    const handleShowPreferences = useCallback(() => {
        showCookiePreferences();
    }, []);

    useEffect(() => {
        if (cookieConsentInitialized) {
            syncCookieConsent(CookieConsent.getCookie());
            if (isApp) {
                CookieConsent.hide();
            }
            return;
        }

        cookieConsentInitialized = true;
        CookieConsent.run({
            ...cookies,
            onConsent: ({ cookie }) => {
                syncCookieConsent(cookie);
            },
            onChange: ({ cookie }) => {
                syncCookieConsent(cookie);
            },
        }).then(() => {
            syncCookieConsent(CookieConsent.getCookie());
            if (isApp) {
                CookieConsent.hide();
            }
        });
    }, [isApp, syncCookieConsent]);

    return { optionalCookieAccepted, requiredCookieAccepted, handleShowPreferences };
};

export default useCookies;
